import React, { useState } from "react";
import "./VH.css";
import { useTranslation } from 'react-i18next';
function VH() {
    const [active, setActive] = useState("first");
     const { t, i18n } = useTranslation();
     const changeLanguage = (e) => {
        i18n.changeLanguage(e.target.value);
    }; 
    return (
        <div id='vh' className=" vh flex flex-col " data-aos="zoom-in" >
            <h2 className="text-[#1D2951] titre bg-[#F3EFDD] vht font1 md:text-4xl lg:text-[2.6rem] text-center lg:-mt-9  mb-8 md:mb-12 px-4">
                {t('vh.vh_title')}
            </h2>
            <div
                className="bg-[url('assets/Backgrounds/vh3.jpg')] bg-[#F3EFDD] bg-cover bg-center rounded-[35px] 
                           mx-4 sm:mx-8 md:mx-10 lg:mx-[10vw] 
                           min-h-[450px] h-auto pb-12 th 
                           relative flex flex-col items-center text-white  overflow-hidden">

                <div className="flex bg-white rounded-[35px] border border-gray-200
                                w-11/12 max-w-xl sm:max-w-2xl mt-8 relative z-10 overflow-hidden">
                    <button
                        onClick={() => setActive("first")}
                        className={`flex-1 p-3 font4 plf rounded-[35px] md:p-4 text-center text-sm sm:text-lg font-bold  transition duration-400 ease-in-out outline-none rounded-l-[35px] ${active === "first"
                            ? "bg-[#D8B273] text-[#243155] scale-[1.01] "
                            : "text-[#243155] hover:bg-gray-50 " 
                            }`}>
                        {t('vh.Horraire_title')}
                    </button>
                    <button
                        onClick={() => setActive("second")}
                        className={`flex-1 p-3 plf font4 rounded-[35px]  md:p-4 text-center text-sm sm:text-lg font-bold  transition duration-400 ease-in-out outline-none rounded-r-[35px] ${active === "second"
                            ? "bg-[#D8B273] text-[#243155] scale-[1.01]"
                            : "text-[#243155] hover:bg-gray-50"
                            }`}>
                        {t('vh.prix_title')}
                    </button>
                </div>

                <div className="w-full flex justify-center pt-8 px-6 sm:px-10 lg:px-[5%]">
                    {active === "first" && (
                        <div className="">

                            <div className="flex flex-col justify-center w-full items-center">
                                <p className=" plf  text-white font4 text-base text-center md:text-xl lg:text-xl font-light leading-relaxed w-full">
                                    {t('vh.Horraire_p1')}
                                </p>
                            </div>

                            <div className="mt-8 flex flex-col items-center border border-[#CF9242] rounded-xl pt-6">
                                <div className="title mb-2 flex flex-row items-center">
                                    <img alt="ellipse" src="assets/icons/Ellipse.png" className="w-9 h-9 mt-3 " />
                                    <h3 className=" plf text-[#E7C8A0] font4 text-xl sm:text-2xl font-bold">{t('vh.Horraire_title')}</h3>
                                </div>
                                <div className=" plf text-lg sm:text-xl justify-between mx-9 font4 mt-2 ">
                                    <p>{t('vh.Horraire_p2')}</p><br></br>
                                </div>
                                
                            </div>
                        </div>
                    )}

                    {active === "second" && (
                        <div className="flex flex-col justify-around xl:justify-around md:flex-row md:justify-around lg:justify-around gap-8 md:gap-12 mt-5 w-full max-w-4xl">
                            {/* Col 1: Pour les Marocains */}
                            <div className="w-full md:w-1/2">
                                <div className="title mb-2 flex flex-row items-center justify-center">
                                    <img src="assets/icons/Ellipse.png" alt="frame" className="w-9 h-9 " />
                                    <h3 className=" plf text-xl sm:text-2xl font-bold mb-4 text-center">{t('vh.prix_m')}</h3>
                                </div>
                                <div className=" plf space-y-3">
                                    {[
                                        { label: t('vh.prix_personne'), price: t('vh.prix_personneM_value'), icon: "assets/icons/personne.png" },
                                        { label: t('vh.prix_groupe'), price: t('vh.prix_groupeM_value'), icon: "assets/icons/groupe.png" },
                                        { label: t('vh.prix_enfant'), price: t('vh.prix_enfantM_value'), icon: "assets/icons/personne.png" },
                                    ].map((item, index) => (
                                        <div
                                            key={index}
                                            className="flex justify-between items-center w-full py-2 border-white/40"
                                        >
                                      
                                            <div className="flex items-center gap-3">
                                                <img src={item.icon} alt=""  />
                                                <p className="text-lg font-medium">{item.label}</p>
                                            </div>
                                            <p className="text-lg font-medium">{item.price}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="w-full md:w-1/2 mt-8 md:mt-0">
                                <div className="title mb-2 flex flex-row items-center justify-center">
                                    <img src="assets/icons/Ellipse.png" alt="frame" className="w-9 h-9 " />
                                    <h3 className=" plf text-xl sm:text-2xl font-bold mb-4 text-center">{t('vh.prix_e')}</h3>
                                </div>                                
                                <div className=" plf space-y-3">
                                    {[
                                        { label: t('vh.prix_personne'), price: t('vh.prix_personneE_value'), icon: "assets/icons/personne.png" },
                                        { label: t('vh.prix_groupe'), price: t('vh.prix_groupeE_value'), icon: "assets/icons/groupe.png" },
                                    ].map((item, index) => (
                                        <div
                                            key={index}
                                            className="flex justify-between items-center w-full py-2 border-white/40"
                                        >
                                            <div className="flex items-center gap-3">
                                                <img src={item.icon} alt="" />
                                                <p className="text-lg font-medium">{item.label}</p>
                                            </div>
                                            <p className="text-lg font-medium">{item.price}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default VH;